module.exports = __webpack_public_path__ + "img/marker-oil-produce-green.1f24485a.png";